import { render, staticRenderFns } from "./DocumentCreateFolderDialog.vue?vue&type=template&id=ea8a6d62"
import script from "./DocumentCreateFolderDialog.vue?vue&type=script&lang=js"
export * from "./DocumentCreateFolderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports